export default function (app) {
  app.factory('klNotificationService', [
    '$q',
    '$timeout',
    function ($q, $timeout) {
      let notification;
      let notificationStatus = 'neutral';

      const putError = function (type, message, delay = 5000) {
        notification = message;
        notificationStatus = 'error';

        $timeout(() => (notification = null), delay);
        return $q.reject(message);
      };

      const putSuccess = function (message) {
        notification = message;
        notificationStatus = 'success';
        $timeout(() => (notification = null), 3500);
      };

      const getNotification = function () {
        return notification;
      };

      const getNotificationStatus = function () {
        return notificationStatus;
      };

      return {
        putError,
        putSuccess,
        getNotification,
        getNotificationStatus,
      };
    },
  ]);
}
